import moment from "moment";

export const sortByDate = (a, b) =>
  moment(b.service_date, "DD/MM/YYYY") - moment(a.service_date, "DD/MM/YYYY");
